import Dictionary from './dictionary';
import DictionaryFactory from './dictionary-factory';
import DictionaryContainer from './dictionary-container';
import DomainDictionaryFactory from './factory/domain';
import DepartmentDictionaryFactory from './factory/department';
import RoomDictionaryFactory from './factory/room';
import OrgCompanyDictionaryFactory from './factory/org-company';
import OrgDepartmentDictionaryFactory from './factory/org-department';
import OrgProjectDictionaryFactory from './factory/org-project';
import OrgEmployeeDictionaryFactory from "./factory/org-employee";
import OrgPersonDictionaryFactory from "./factory/org-person";
import AssetAttributeDictionaryFactory from "./factory/asset-attribute";

const dictionaryContainer = new DictionaryContainer({});
dictionaryContainer.registerFactory(new DomainDictionaryFactory()); // domain
dictionaryContainer.registerFactory(new DepartmentDictionaryFactory()); // department
dictionaryContainer.registerFactory(new RoomDictionaryFactory()); // room
dictionaryContainer.registerFactory(new OrgCompanyDictionaryFactory()); // org_company
dictionaryContainer.registerFactory(new OrgDepartmentDictionaryFactory()); // org_department
dictionaryContainer.registerFactory(new OrgProjectDictionaryFactory()); // org_project
dictionaryContainer.registerFactory(new OrgEmployeeDictionaryFactory()); // org_employee
dictionaryContainer.registerFactory(new OrgPersonDictionaryFactory()); // org_person
dictionaryContainer.registerFactory(new AssetAttributeDictionaryFactory()); // AssetAttribute


export {Dictionary, DictionaryFactory, DictionaryContainer, dictionaryContainer};

export * from './dictionary';
export * from './dictionary-factory';
export * from './dictionary-container';
export * from './factory/domain';
export * from './factory/department';
export * from './factory/room';
export * from './factory/org-company';
export * from './factory/org-department';
export * from './factory/org-project';
export * from './factory/org-employee';
export * from './factory/org-person';
